<template>
	<div id="page-wrapper">
		<div class="row page-titles no-print">
			<div class="col-md-5 align-self-center">
				<h3 class="text-themecolor">{{ $t('nav.ap') }}</h3>
			</div>
			<div class="col-md-7 align-self-center">
				<ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.cost') }}</a></li>
					<li class="breadcrumb-item active">{{ $t('nav.ap') }}</li>
				</ol>
			</div>
		</div>
		<div class="container-fluid">
			<!-- /row -->
			<div class="row">
				<div class="col-md-12 col-sm-12">
					<div class="card">
						<div class="card-header">
							<h4>{{ $t('ap.pay-sheet') }}</h4>
						</div>
						<div class="card-body">
							<div class="row text-center">
								<div class="col-md-12 no-print">
									<a href="javascript:window.print()" class="btn btn-danger">{{ $t('ap.print') }}</a>
								</div>
							</div>
							
							<div class="row mrg-0">
								<div class="col-md-6">
									<div id="logo"><img src="/img/logo-small.svg" width="200" height="30" class="img-responsive" alt=""></div>
								</div>
								<div class="col-md-6">	
									<p id="invoice-info">
										<strong>{{ $t('ap.pay-no') }}:</strong> #{{ ap.id }} <br>
										<strong>{{ $t('ap.issue-date') }}:</strong> {{ ap.createAt }} <br>
										<strong>{{ $t('ap.pay-date') }}:</strong> {{ ap.payDate }} <br>
										<strong>{{ $t('ap.priority') }}:</strong> {{ getPriority(ap.priority) }} <br>
										<span>{{ $t('ap.due-date', { day: days }) }}</span>
									</p>
								</div>
							</div>
							<div class="row  mrg-0 detail-invoice">
								<div class="col-md-12">
									<h2>{{ $t('ap.info') }}</h2>
								</div>
								<div class="col-md-12">
									<div class="row">
									  <div class="col-lg-7 col-md-7 col-sm-7">
										<h4>{{ $t('ap.vendor') }}: </h4>
										<h5>{{ ap.vendor.name }} - {{ ap.vendor.officialName }}</h5>
										<p>
											{{ ap.vendor.contactPerson }}<br />
											<span v-if="ap.vendor.email">{{ ap.vendor.email }}<br /></span>
											{{ ap.vendor.phoneNumber }}<br />
											<span v-if="ap.vendor.address">{{ ap.vendor.address }}</span>
										</p>
										<p>
											{{ $t('vendor.bank-name') }}: {{ ap.vendor.bankName }}<br/>
											{{ $t('vendor.bank-account') }}: {{ ap.vendor.bankAccount }}<br/>
											<span v-if="ap.vendor.taxNo">{{ $t('vendor.tax-no') }}: {{ ap.vendor.taxNo }}</span>
										</p>
									  </div>
									  <div class="col-lg-5 col-md-5 col-sm-5">
										<h4>{{ $t('ap.initiator') }}:</h4>
										<h5>{{ ap.createUser }}</h5>
										<p>
											{{ getLegalEntity(ap.legalEntityId) }}
										</p>
										<p>
											<strong>{{ $t('ap.category') }}:</strong> <br />
											{{ getCostCategory(ap.costCategory) }}
										</p>
										<p>
											<strong>{{ $t('ap.comment') }}:</strong> <br />
											{{ ap.comment }}
										</p>										
									  </div>
									</div>
								</div>
								
								<div class="col-12 col-md-12" v-if="JSON.stringify(ap.contract) != '{}'">
									<hr />
									<strong>{{ $t('ap.contract-info') }}:</strong>
									<div class="invoice-table">
										<div class="table-responsive">
											<table class="table table-striped table-bordered">
												<thead>
													<tr>
														<th>{{ $t('vendor.contract.name') }}</th>
														<th>{{ $t('vendor.contract.le') }}</th>
														<th>{{ $t('vendor.contract.signed-date') }}</th>
														<th>{{ $t('vendor.contract.signed-person') }}</th>
														<th>{{ $t('vendor.contract.value') }}</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>{{ ap.contract.name }}</td>
														<td>{{ ap.contract.legalEntity }}</td>
														<td>{{ ap.contract.signedDate }}</td>
														<td>{{ ap.contract.signedPerson }}</td>
														<td>{{ ap.contract.contractValue }}</td>
													</tr>
												</tbody>
											</table>
										</div>										
									</div>
								</div>
								<div class="col-12 col-md-12" v-if="ap.invoiceInfo.length > 0">
									<hr />
									<strong>{{ $t('ap.invoice-info') }}:</strong>
									<div class="invoice-table">
										<div class="table-responsive">
											<table class="table table-striped table-bordered">
												<thead>
													<tr>
														<th>{{ $t('vendor.invoice.invoice-date') }}</th>
														<th>{{ $t('vendor.invoice.invoice-type') }}</th>
														<th>{{ $t('vendor.invoice.item') }}</th>
														<th>{{ $t('vendor.invoice.invoice-value') }}</th>
														<th>{{ $t('vendor.invoice.le') }}</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="i in ap.invoiceInfo">
														<td>{{ i.invoiceDate }}</td>
														<td>{{ getInvoiceType(i.invoiceType) }}</td>
														<td>{{ i.item }}</td>
														<td>{{ i.invoiceValue }}</td>
														<td>{{ getLegalEntity(i.legalEntityId) }}</td>
													</tr>
												</tbody>
											</table>
										</div>										
									</div>
								</div>
								<div class="col-12 col-md-12">
									<h5>{{ $t('ap.invoice-type') }}: {{ getInvoiceType(ap.invoiceType) }}</h5>
								</div>
								
								<div class="col-12 col-md-12">
									<hr>
									<h4>{{ $t('ap.amount') }}: {{ $t('ap.rmb') }} {{ ap.amount }} {{ $t('ap.yuan') }}</h4>
								</div>
							</div>
						</div>
					
					</div>
					<div class="card no-print">
						<div class="card-header">
							<h4>{{ $t('ap.title3') }}</h4>
						</div>
						<div class="card-body">
							<div class="single-comment" v-for="ac in ap.apComment" v-if="ap.apComment.length > 0">
								<div class="img-holder">
									<img :src="'/img/avatar/' + ac.userId + '.jpeg'" class="img-responsive" alt="">
								</div>
								<div class="text-holder">
									<div class="top">
										<div class="name pull-left">
											<h4>{{ ac.user }}</h4>
										</div>
										<div class="rating pull-right">
											<el-tag :type="ac.status === 0 ? 'danger' : 'success'">{{ ac.status === 0 ? $t('ap.disapprove') : $t('ap.approve') }}</el-tag>
										</div>
									</div>
									<div class="text" v-if="ac.comment != ''">
										<p>{{ ac.comment }}</p>
									</div>
									<span class="small">{{ ac.createAt | dateFormat('from', $i18n.locale) }}</span>
								</div>
							</div>
							<el-row :gutter="20">
							<el-form ref="form" :model="formData" :rules="formRules">
								<el-col :span="24">
									<el-form-item :label="$t('ap.review-status')">
										<el-switch
										  v-model="formData.status"
										  :active-text="$t('ap.approve')"
										  :inactive-text="$t('ap.disapprove')"
										  style="width:100%">
										</el-switch>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item :label="$t('ap.review-reply')" prop="reply">
										<el-input
										  type="textarea"
										  :autosize="{ minRows: 2, maxRows: 4}"
										  :placeholder="$t('ap.review-comment-ph')"
										  v-model.trim="formData.reply"
										  style="width:100%">
										</el-input>
									</el-form-item>
								</el-col>
							</el-form>	
							</el-row>
							<div class="text-center">
								<el-button type="primary" style="width:100%" @click.prevent="createAPComment">{{ $t('ap.submit') }}</el-button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- /row -->
		</div>	
	</div>
</template>
<style scoped>
@media print {
 	.no-print { display:none; }
}
.comments{
    width: 100%;
    display: block;
    overflow: hidden;
    border-radius: 6px;
    margin-bottom: 40px;
    border: 1px solid #eaeff5;
    box-shadow: 0px 0px 10px 1px rgba(71, 85, 95,0.08);
    -webkit-box-shadow: 0px 0px 10px 1px rgba(71, 85, 95,0.08);
    -moz-box-shadow: 0px 0px 10px 1px rgba(71, 85, 95,0.08);
}
.comments-title{
    padding: 1em 1em 1em 1.5em;
    border-bottom: 1px solid #eaeff5;
}
.comments-title h4 {
    margin: 0;
}
.single-comment {
    position: relative;
    margin-bottom: 10px;
    padding-bottom:20px;
    padding-left: 80px;
	margin-top:10px;
	padding-right: 15px;
}
.single-comment .single-comment {
    padding-left: 80px;
}
.single-comment .img-holder {
    left: 12px;
    border-radius: 50%;
    overflow: hidden;
    width: 50px;
    height: 50px;
    position: absolute;
    top: 0;
	box-shadow:0 2px 10px 0 #d8dde6;
	-webkit-box-shadow:0 2px 10px 0 #d8dde6;
	-moz-box-shadow:0 2px 10px 0 #d8dde6;
}
.single-comment .text-holder {
    border: 1px solid #eaeff5;
    padding: 20px;
}
.single-comment .text-holder .top {
    margin: 0 0 8px;
    overflow: hidden;
}
.rating.pull-right li {
    list-style: none;
    display: inline-block;
}
.rating.pull-right li i {
    font-size: 13px;
    margin-right: 3px;
    color: #636d75;
}
.rating.pull-right li i.active {
    color: #07b107;
}

.comments-form textarea.form-control{
	height:150px;
}
.comments-form form{
	margin:10px -15px;
}
</style>
<script>
import moment from 'moment'

export default {
  name: 'APInfoBox',
  data: function() {
    return {
      ap: null,
      formData: {
      	'id': null,
      	'type': null,
      	'actionId': null,
        'status': false,
        'reply': null,
        'userId': null
      },
      formRules: {
        'reply': [{required: true, message: this.$t('ap.validate.reply'), trigger: 'blur'}]
      }
    }
  },
  computed: {
    days: function() {
      return moment().diff(moment(this.ap.createAt), 'days')
    }
  },
  methods: {
    createAPComment: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formData.actionId = this.$route.params.id
	      this.formData.userId = localStorage.getItem('token')
	      this.formData.type = 'ap'
	      //console.log(this.formData)
	      let that = this
	      this.$http.post(this.API3_PREFIX + 'comment', this.formData).then(function (response) {
	        that.$message({
	          message: that.$t('ap.comment-success'),
	          type: 'success'
	        })
			that.ap.apComment.push(response.data)
			that.$refs.form.resetFields()
	      }).catch(function (error) {
	        that.$message({
	          message: that.$t('ap.comment-failed'),
	          type: 'error'
	        })
			console.log(error)
	      })
        } else {
          // do stuff if not valid.
          this.$message({
	          message: this.$t('ap.invalid'),
	          type: 'error'
	        })
          return false
        }
      })
    },
    loadData: function() {
      let that = this,
          apId = this.$route.params.id
	  this.$http.get(this.API3_PREFIX + 'ap/' + apId).then(function (response) {
		that.ap = response.data
		if (that.ap.contract.legalEntityId && !that.ap.contract.legalEntity)
	    	that.ap.contract.legalEntity = that.getLegalEntity(that.ap.contract.legalEntityId)
		that.ap.vendor.invoice.forEach(function(v) {
		    if (v.legalEntityId && !v.legalEntity) 
		    	v.legalEntity = that.getLegalEntity(v.legalEntityId)
		    v.invoiceTypeName = that.getInvoiceType(v.invoiceType)
		})
      }).catch(function (error) {
		console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>